export const getModalStyling = (styleOverRide = {}) => {
    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(111, 111, 111, 0.62)',
            zIndex: 999,
            boxShadow:
                'rgba(0, 0, 0, 0.117647) -1px 0px 2px 0px, rgba(0, 0, 0, 0.117647) 1px 0px 2px 0px, rgba(0, 0, 0, 0.239216) 0px 1px 1px 0px'
        },
        content: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            minWidth: '300px',
            minHeight: '300px',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '8px',
            outline: 'none',
            padding: '20px',
            boxShadow: '1px 1px 6px rgba(0,0,0,0.35)'
        }
    };
    return {
        overlay: { ...style.overlay, ...styleOverRide.overlay },
        content: { ...style.content, ...styleOverRide.content }
    };
};

export default getModalStyling;
